import { Injectable } from '@angular/core';
import {ChartModel} from '../models/chart';
import {DashboardApi} from '../api/dashboard.api';

@Injectable()
export class ChartDesignVersionManagerService {

  private currentVersion: [number, number, number] = [7,0,1];

  constructor(private dashboardApi: DashboardApi) { }

  getCurrentVersionValue(): string {
    return this.currentVersion.toString().replaceAll(',','.');
  }

  needUpdate(version: string): boolean {
    if (version === '7.0.0' || version === '6.0.0' || version === '5.0.0' || version === '4.0.0' || version === '3.0.0' ||
      version === '2.0.0' || version === '1.0.0' || version === '0.0.1' || version === undefined) {
      return true;
    }
    const splitVersion = version.split('.');
    for (let i = 0; i < this.currentVersion.length; i++){
      if(Number(splitVersion[i]) !== this.currentVersion[i]){
        return true;
      }
      if(i === this.currentVersion.length - 1 && Number(splitVersion[i]) === this.currentVersion[i]){
        return false;
      }
    }
    return true;
  }

  updateDesignSettings(chart: Partial<ChartModel>): any {
    if(chart.chartDesignSettings.version === '0.0.1' || chart.chartDesignSettings.version === undefined) {
      chart.chartDesignSettings = this.updateToVersion1o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion2o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion3o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion4o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion5o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion6o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if(chart.chartDesignSettings.version === '1.0.0') {
      chart.chartDesignSettings = this.updateToVersion2o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion3o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion4o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion5o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion6o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if(chart.chartDesignSettings.version === '2.0.0') {
      chart.chartDesignSettings = this.updateToVersion3o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion4o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion5o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion6o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if(chart.chartDesignSettings.version === '3.0.0') {
      chart.chartDesignSettings = this.updateToVersion4o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion5o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion6o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if(chart.chartDesignSettings.version === '4.0.0') {
      chart.chartDesignSettings = this.updateToVersion5o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion6o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if(chart.chartDesignSettings.version === '5.0.0') {
      chart.chartDesignSettings = this.updateToVersion6o0o0(chart);
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if (chart.chartDesignSettings.version === '6.0.0') {
      chart.chartDesignSettings = this.updateToVersion7o0o0(chart);
      return this.updateToVersion7o0o1(chart);
    }
    if (chart.chartDesignSettings.version === '7.0.0') {
      return this.updateToVersion7o0o1(chart);
    }

    return chart.chartDesignSettings;
  }

  updateToVersion1o0o0(chart: Partial<ChartModel>): any {
    if(chart.chartType === 'LineChart') {
      chart.chartDesignSettings.chart.columnsLineStyleOptions = {};
      chart.chartDesignSettings.chart.columnsPointStyleOptions = {};
      chart.chartDesignSettings.chart.toggleLegendLimitChars= true;
      chart.chartDesignSettings.chart.legendMaxChars= 10;
      chart.chartDesignSettings.chart.toggleLabelMoreSetting= false;
      chart.chartDesignSettings.chart.labels= {};
      chart.chartDesignSettings.chart.labels.columns= {};
      chart.chartDesignSettings.chart.columnsLineStyleOptions.styleOnEachColumn= false;
      chart.chartDesignSettings.chart.columnsLineStyleOptions.allLineType= 'line';
      chart.chartDesignSettings.chart.columnsLineStyleOptions.columns = {};
      chart.chartDesignSettings.chart.columnsPointStyleOptions.pointOnEachColumn= false;
      chart.chartDesignSettings.chart.columnsPointStyleOptions.allPointStyle= 'line';
      chart.chartDesignSettings.chart.columnsPointStyleOptions.allPointRadius= 0;
      chart.chartDesignSettings.chart.columnsPointStyleOptions.columns = {};
      chart.chartDesignSettings.chart.tension= 0;
      chart.chartDesignSettings.chart.stepped = false;
    }
    chart.chartDesignSettings.version = '1.0.0';
    return chart.chartDesignSettings;
  }

  updateToVersion2o0o0(chart: Partial<ChartModel>): any {
    chart.chartDesignSettings.version = '2.0.0';
    this.dashboardApi.resetChartColors(chart.workspaceId,chart.dashboardId,chart.chartId,1).subscribe();
    return chart.chartDesignSettings;
  }

  updateToVersion3o0o0(chart: Partial<ChartModel>): any {
    if(chart.chartType === 'AreaChart') {
      chart.chartDesignSettings.chart.columnsLineStyleOptions = {};
      chart.chartDesignSettings.chart.columnsPointStyleOptions = {};
      chart.chartDesignSettings.chart.toggleLegendLimitChars= true;
      chart.chartDesignSettings.chart.legendMaxChars= 10;
      chart.chartDesignSettings.chart.toggleLabelMoreSetting= false;
      chart.chartDesignSettings.chart.labels= {};
      chart.chartDesignSettings.chart.labels.columns= {};
      chart.chartDesignSettings.chart.columnsLineStyleOptions.styleOnEachColumn= false;
      chart.chartDesignSettings.chart.columnsLineStyleOptions.allLineType= 'line';
      chart.chartDesignSettings.chart.columnsLineStyleOptions.columns = {};
      chart.chartDesignSettings.chart.columnsPointStyleOptions.pointOnEachColumn= false;
      chart.chartDesignSettings.chart.columnsPointStyleOptions.allPointStyle= 'line';
      chart.chartDesignSettings.chart.columnsPointStyleOptions.allPointRadius= 0;
      chart.chartDesignSettings.chart.columnsPointStyleOptions.columns = {};
      chart.chartDesignSettings.chart.tension= 0;
      chart.chartDesignSettings.chart.stepped = false;
    }
    if(chart.chartType === 'BarChart' || chart.chartType === 'BarChartHorizontal' ||
      chart.chartType === 'StackedBarChart' || chart.chartType === 'Stacked100BarChart') {
      chart.chartDesignSettings.chart.toggleLabelMoreSetting= false;
      chart.chartDesignSettings.chart.labels= {};
      chart.chartDesignSettings.chart.labels.columns= {};
      chart.chartDesignSettings.chart.toggleLegendLimitChars= true;
      chart.chartDesignSettings.chart.legendMaxChars= 10;
    }
    chart.chartDesignSettings.version = '3.0.0';
    return chart.chartDesignSettings;
  }

  updateToVersion4o0o0(chart: Partial<ChartModel>): any {
    if(chart.chartType === 'TableChart') {
      chart.chartDesignSettings.chart.fontOnEachColumns = false;
      chart.chartDesignSettings.chart.fontOptionsOnEachColumns = {};
      chart.chartDesignSettings.chart.isColorOnEachColumns = false;
      chart.chartDesignSettings.chart.colorOnEachColumns = {};
    }
    chart.chartDesignSettings.version = '4.0.0';
    return chart.chartDesignSettings;
  }

  updateToVersion5o0o0(chart: Partial<ChartModel>): any {
    if(chart.chartType === 'ClusteredColumnLineChart' || chart.chartType === 'StackedColumnLineChart') {
      chart.chartDesignSettings.chart.headerAlignmentOption = 'Right';
      chart.chartDesignSettings.chart.tension = 0;
      chart.chartDesignSettings.chart.transparentDisplay = false;
      chart.chartDesignSettings.chart.toggleLegendLimitChars = true;
      chart.chartDesignSettings.chart.legendMaxChars = 10;
      chart.chartDesignSettings.chart.dataLanguage = 'Fa';
      chart.chartDesignSettings.axises.x.scaleName = 'گسسته';
      chart.chartDesignSettings.axises.x.scaleColor = '#0000001A';
      chart.chartDesignSettings.axises.x.scaleFontFamily = 'iranyekan';
      chart.chartDesignSettings.axises.x.scaleFontSize = 11;
      chart.chartDesignSettings.axises.x.scaleTextColor = '#666';
      chart.chartDesignSettings.axises.x.toggleLimitChars = true;
      chart.chartDesignSettings.chart.toggleLabelMoreSetting= false;
      chart.chartDesignSettings.chart.labels= {};
      chart.chartDesignSettings.chart.labels.columns= {};
      chart.chartDesignSettings.chart.columnsLineStyleOptions = {};
      chart.chartDesignSettings.chart.columnsPointStyleOptions = {};
      chart.chartDesignSettings.chart.columnsLineStyleOptions.styleOnEachColumn= false;
      chart.chartDesignSettings.chart.columnsLineStyleOptions.allLineType= 'line';
      chart.chartDesignSettings.chart.columnsLineStyleOptions.columns = {};
      chart.chartDesignSettings.chart.columnsPointStyleOptions.pointOnEachColumn= false;
      chart.chartDesignSettings.chart.columnsPointStyleOptions.allPointStyle= 'line';
      chart.chartDesignSettings.chart.columnsPointStyleOptions.allPointRadius= 0;
      chart.chartDesignSettings.chart.columnsPointStyleOptions.columns = {};
      chart.chartDesignSettings.axises.x.maxChars = 10;
    }
    chart.chartDesignSettings.version = '5.0.0';
    return chart.chartDesignSettings;
  }

  updateToVersion6o0o0(chart: Partial<ChartModel>): any {
    if(chart.chartType === 'PieChart' || chart.chartType === 'DoughnutChart') {
      chart.chartDesignSettings.chart.transparentDisplay = false;
      chart.chartDesignSettings.chart.headerAlignmentOption = 'Right';
      chart.chartDesignSettings.chart.dataLanguage = 'Fa';
      chart.chartDesignSettings.chart.toggleLegendLimitChars = true;
      chart.chartDesignSettings.chart.legendMaxChars = 10;
      chart.chartDesignSettings.chart.toggleLabelMoreSetting = false;
      chart.chartDesignSettings.chart.labels = {};
      chart.chartDesignSettings.chart.labels.columns = {};
    }
    if(chart.chartType === 'BarChart' || chart.chartType === 'BarChartHorizontal' ||
    chart.chartType === 'StackedBarChart' || chart.chartType === 'Stacked100BarChart') {
      chart.chartDesignSettings.chart.transparentDisplay = false;
      chart.chartDesignSettings.chart.headerAlignmentOption = 'Right';
      chart.chartDesignSettings.chart.dataLanguage = 'Fa';
      chart.chartDesignSettings.axises.y.place = chart.chartType === 'BarChartHorizontal' ? 'پایین' :
          chart.chartDesignSettings.axises.y.place;
    }
    if(chart.chartType === 'ClusteredColumnLineChart' || chart.chartType === 'StackedColumnLineChart') {
      chart.chartDesignSettings.axises.y.lineToggle = true;
      chart.chartDesignSettings.axises.y2.lineToggle = true;
    }
    chart.chartDesignSettings.version = '6.0.0';
    return chart.chartDesignSettings;
  }

  updateToVersion7o0o0(chart: Partial<ChartModel>): any {
    if (chart.chartType === 'RadarChart') {
      chart.chartDesignSettings.axises = {
        r: {
          titrToggle: true,
          titrFontFamily: 'iranyekan',
          titrFontSize: 10,
          titrColor: '#4D4D4D',
          unitName: 'ﺑﺪون واﺣﺪ',
        },
      };
    }
    chart.chartDesignSettings.version = '7.0.0';
    return chart.chartDesignSettings;
  }

  updateToVersion7o0o1(chart: Partial<ChartModel>): any {
    if (chart.chartType === 'LineChart' || chart.chartType === 'AreaChart') {
      Object.keys(chart.chartDesignSettings.chart.columnsLineStyleOptions.columns).forEach((key, index) => {
        chart.chartDesignSettings.chart.columnsLineStyleOptions.columns[key] = {
          style: chart.chartDesignSettings.chart.columnsLineStyleOptions.columns[key],
          width: 3,
        };
      });
    }
    chart.chartDesignSettings.version = this.getCurrentVersionValue();
    this.dashboardApi.updateChartDesign(chart.workspaceId, chart.dashboardId, chart).subscribe();
    return chart.chartDesignSettings;
  }
}
